import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';

const Product = () => {

     const [slideList, SetSlideList] = useState([]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        //dotsClass: "button__bar",
        customPaging: i => (
            <button className="slick-dot"></button>
        ),
    };

    const urlImg = `${process.env.REACT_APP_BASEURL}/galeri/`;


    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/image_slideshow`)
                .then((res) => {
                    return res.json();
                })
                .then((datas) => {
                    //console.log(datas);
                    SetSlideList(datas.data);
                });
        }, []);


    return (
        <div className="max-w-full mx-auto">
            <div className="w-full mx-auto items-center overflow-x-scroll" style={{ msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
                <Slider {...settings}>
                    {slideList.map((data, index) => (
                        <img src={urlImg + '' + data.file} alt="Image" className="w-full" />
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default Product;
